import React, { useCallback, useEffect, useRef, useState } from "react";

import { FlagBrazil } from "../../../svg/FlagBrazil";

import { IInputDefault } from "../../../interfaces/input";
import { IStatus } from "../../../interfaces/status";

import { useMask } from "../../../hooks/useMask";
import { useName } from "../../../hooks/useName";
import { useInformations } from "../../../hooks/useInformations";

import { Informations } from "../../Informations";

import { Container, Input, FlagContainer } from "./styles";

export const Tel: React.FC<IInputDefault> = (props) => {
  const myRef = useRef(null);

  const { name } = useName(props.name);

  const { mask } = useMask();

  const [value, setValue] = useState<string>("");

  useEffect(() => {
    setValue(props.value as string);
  }, [props.value]);

  const onChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const { name, value } = event.target;

    setValue(value);

    props.onChange && props.onChange(name, value, event);
  };

  useEffect(() => {
    const phoneMask = function (val: any) {
      return val.replace(/\D/g, "").length === 11
        ? "(00) 00000-0000"
        : "(00) 0000-00009";
    };
    const phoneOptionsMask = {
      onKeyPress: function (val: any, _e: any, field: any, options: any) {
        field.mask(phoneMask(val), options);
      },
    };
    const inputEl: Element = myRef.current!;
    mask(inputEl, { value: phoneMask, options: phoneOptionsMask });
  }, []);

  const [status, setStatus] = useState<IStatus>("VALIDATED");

  const validate = useCallback(() => {
    if (props.required && !value) {
      setStatus("ERROR_REQUIRED");
      return;
    }

    setStatus("VALIDATED");
  }, [props.required, value]);

  useEffect(() => {
    validate();
  }, [validate]);

  const informationsRef = useRef(null);

  const { informations, onValidate, getInformationsClasses } = useInformations({
    ref: informationsRef,
    inputProps: props,
  });

  return (
    <Container>
      <Input className={`input-tel ${props.disabled ? "disabled" : ""}`}>
        <FlagContainer
          {...{
            className: `flag-container-tel ${getInformationsClasses()} ${
              props.disabled ? "disabled" : ""
            }`,
          }}
        >
          <FlagBrazil />
        </FlagContainer>

        <input
          {...{
            name,
            value,
            onChange,
            ref: myRef,
            type: "tel",
            "data-status": status,
            onBlur: (event) => {
              const { name, value } = event.currentTarget;

              props.onChange && props.onChange(name, value, event);

              setValue(value);

              onValidate(event);
            },
            className: getInformationsClasses(),
            "data-input": "tel",
            placeholder: props.placeholder,
            disabled: props.disabled,
          }}
        />
      </Input>
      <Informations
        {...{
          name,
          ref: informationsRef,
          ...informations,
        }}
      />
    </Container>
  );
};
